/* eslint-disable jsx-a11y/anchor-is-valid */
import _ from 'underscore';
import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { DefaultButton, PrimaryButton, Link } from '@bingads-webui-react/fabric-with-signal';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useIsReadOnlyUser } from '@bingads-webui-campaign-react/mca-core';

import { getStepFooterStyles } from '../styles/step-footer-styles';

export function StepFooter(props) {
  const {
    previousButtonLabel,
    nextButtonLabel,
    onPreviousClick,
    onNextClick,
    onCancelClick,
    onSkippingLinkClick,
    skippingLinkTitle,
    onRenderLinkContainer,
    errorMessage,
    isNextButtonDisabled,
    disableButtons,
  } = props;
  const classes = useDefaultStyles(getStepFooterStyles);
  const i18n = useContext(I18nContext);
  const isReadOnlyUser = useIsReadOnlyUser();

  return (
    <div className={classNames('step-footer', classes.footerContainer)}>
      {
        _.isFunction(onPreviousClick) &&
        <DefaultButton
          className={classNames('step-previous-btn', classes.previousButton)}
          onClick={onPreviousClick}
          name="BackButtonOnStepFooter"
          disabled={disableButtons}
        >
          {previousButtonLabel || i18n.getString(_TL_('Back'))}
        </DefaultButton>
      }

      {
        _.isFunction(onNextClick) &&
        <PrimaryButton
          className={classNames('step-next-btn', classes.primaryButton)}
          onClick={onNextClick}
          disabled={disableButtons || isReadOnlyUser || isNextButtonDisabled}
          name="NextButtonOnStepFooter"
        >
          {nextButtonLabel || i18n.getString(_TL_('Next'))}
        </PrimaryButton>
      }

      {
        _.isFunction(onCancelClick) &&
        <DefaultButton
          className={classNames('step-cancel-btn', classes.cancelButton)}
          onClick={onCancelClick}
          name="CancelButtonOnStepFooter"
          disabled={disableButtons}
        >
          {i18n.getString(_TL_('Cancel'))}
        </DefaultButton>
      }

      {
        _.isFunction(onSkippingLinkClick) && !_.isEmpty(skippingLinkTitle) &&
        <Link
          className={classNames(['link-button', 'step-skip-btn', classes.skippingLink])}
          onClick={onSkippingLinkClick}
          disabled={isReadOnlyUser || disableButtons}
          name="SkipButtonOnStepFooter"
        >
          {skippingLinkTitle}
        </Link>
      }

      {_.isFunction(onRenderLinkContainer) && onRenderLinkContainer()}

      {errorMessage && <span className={classNames('error-message', classes.errorMessage)}>{errorMessage}</span>}
    </div>
  );
}

StepFooter.propTypes = {
  previousButtonLabel: PropTypes.string,
  nextButtonLabel: PropTypes.string,
  onPreviousClick: PropTypes.func,
  onNextClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  onSkippingLinkClick: PropTypes.func,
  skippingLinkTitle: PropTypes.string,
  onRenderLinkContainer: PropTypes.func,
  errorMessage: PropTypes.string,
  isNextButtonDisabled: PropTypes.bool,
  disableButtons: PropTypes.bool,
};

StepFooter.defaultProps = {
  previousButtonLabel: null,
  nextButtonLabel: null,
  onPreviousClick: null,
  onNextClick: null,
  onCancelClick: null,
  onSkippingLinkClick: null,
  skippingLinkTitle: null,
  onRenderLinkContainer: null,
  errorMessage: null,
  isNextButtonDisabled: false,
  disableButtons: false,
};
